module.exports = __webpack_public_path__ + "img/production3.c97811d2.png";